import React from 'react';
import styled from 'styled-components';
import { AnimatePresence } from "framer-motion"

import { FaChevronUp, FaChevronDown } from 'react-icons/fa'
import { Paper, PopOut, Animation } from 'components'

const Options = styled.div`
    width: 8rem;
    border-radius: 5px;
    font-size: 0.9rem;
    background-color: ${props => props.styles.primaryColor};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
`

const OptionBlock = styled.div`
    box-sizing: border-box;
    border-radius: 5px;
    width: 100%;
    padding: 0.5rem 1rem;
    cursor: pointer;
    box-sizing: border-box;
    background-color: ${props => props.styles.primaryColor};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const defaultStyles = {
    primaryColor: 'var(--primary-color)'
}

const InsertOptions = props => {
    const {
        onSelect,
        // setOption,
        // option,
        styles
    } = props;
    const updatedStyles = Object.assign({}, defaultStyles, styles)
    const [option, setOption] = React.useState('default')
    const onSelectHandler = (event, value) => {
        onSelect(value)
        props.closeHandler && props.closeHandler()
        setOption('default')
    }

    let options
    switch(option){
        case 'main':
            options =
            <AnimatePresence key='main'>
                <Animation key='main' animation='exitRight'>
                    <OptionBlock styles={updatedStyles} onClick={() => setOption('heading')}>Heading</OptionBlock>
                    {/* <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'CODE_BLOCK')}>Code block</OptionBlock> */}
                    <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'BLOCKQUOTE')}>Quote block</OptionBlock>
                    <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'DIVIDER')}>Divider</OptionBlock>
                    <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'IMAGE')}>Image</OptionBlock>
                </Animation>
            </AnimatePresence>
            break

        case 'heading':
            options = 
            <AnimatePresence key='heading'>
                <Animation key='heading' animation='slideLeft'>
                    <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'HEADER_ONE')}>Heading 1</OptionBlock>
                    <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'HEADER_TWO')}>Heading 2</OptionBlock>
                    <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'HEADER_THREE')}>Heading 3</OptionBlock>
                </Animation>
            </AnimatePresence>
            break
            
        default:
            options =
            <AnimatePresence key='default'>
                <Animation key='default'>
                    <OptionBlock styles={updatedStyles} onClick={() => setOption('heading')}>Heading</OptionBlock>
                    {/* <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'CODE_BLOCK')}>Code block</OptionBlock> */}
                    <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'BLOCKQUOTE')}>Quote block</OptionBlock>
                    <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'DIVIDER')}>Divider</OptionBlock>
                    <OptionBlock styles={updatedStyles} onClick={(event) => onSelectHandler(event, 'IMAGE')}>Image</OptionBlock>
                </Animation>
            </AnimatePresence>
    }


    return (
        <Paper primaryColor='var(--secondary-accent-color)' style={{margin: '0.5rem 0 0 0'}}>
            <Options styles={updatedStyles}>{options}</Options>
        </Paper>
    )
}

export default InsertOptions